// ButtonBar — Tally's signature right-edge function-key panel, restyled to the
// AONE design system (light surface + green accent, not the retro green slab).
// Rendered ONCE near the app root inside <TallyKeyboardProvider>; it reads the
// merged active keys and shows itself only when a finance screen registered some.
import React from 'react';
import { useTallyButtons } from '../../context/TallyKeyboardContext';
import { T } from '../../design-system';
import { FIORI as F } from '../../design-system/fiori';

// The Tally lane's accent is the shared Fiori action colour, so finance
// screens match the rest of the ERP instead of carrying their own green.
const GREEN = F.blue;

export default function ButtonBar() {
  const { buttons, press } = useTallyButtons();
  if (!buttons.length) return null;

  return (
    <div
      style={{
        position: 'fixed', right: 0, top: '50%', transform: 'translateY(-50%)',
        width: 132, display: 'flex', flexDirection: 'column', gap: 6, padding: '12px 10px',
        background: T.surface || '#fff',
        border: `1px solid ${T.border || T.border}`, borderLeft: `3px solid ${GREEN}`,
        borderRadius: '10px 0 0 10px', boxShadow: '-6px 0 20px rgba(16,24,40,0.10)',
        zIndex: 1200,
      }}
    >
      <div style={{ fontSize: T.type.xxs, fontWeight: 800, letterSpacing: '0.12em', color: GREEN, textAlign: 'center', marginBottom: 2 }}>
        FUNCTION KEYS
      </div>
      {buttons.map(b => (
        <button
          key={b.key}
          onClick={() => press(b.key)}
          title={b.hint}
          style={{
            display: 'flex', alignItems: 'center', gap: 8, width: '100%',
            background: '#F7F8FA', border: `1px solid ${T.border || T.border}`,
            borderRadius: 6, padding: '6px 8px', cursor: 'pointer', textAlign: 'left',
          }}
        >
          <span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: T.type.xs, color: '#fff', background: b.color || GREEN, borderRadius: 4, padding: '2px 5px', minWidth: 26, textAlign: 'center' }}>
            {b.key.replace('Escape', 'Esc')}
          </span>
          <span style={{ fontSize: T.type.xs, fontWeight: 600, color: T.text }}>{b.label}</span>
        </button>
      ))}
    </div>
  );
}
